import React from 'react';
import { defineMessages } from 'react-intl';
import {
  DrinkAlcoholic,
  Lunch,
  PingPong,
  Security,
  Stereo,
  TableSettings,
  Toilet
} from '../../shared-components/icons';

const translationMessages = defineMessages({
  food_beverage: {
    id: 'hosting.pages_collection.food_beverage',
    defaultMessage: 'Food and beverage'
  },
  alcoholic_beverages: {
    id: 'hosting.pages_collection.alcoholic_beverages',
    defaultMessage: 'Alcoholic beverages'
  },
  furniture: {
    id: 'hosting.pages_collection.furniture',
    defaultMessage: 'Furniture'
  },
  restrooms: {
    id: 'hosting.pages_collection.restrooms',
    defaultMessage: 'Restrooms'
  },
  av_music: {
    id: 'hosting.pages_collection.av_music',
    defaultMessage: 'AV and music'
  },
  event_activities: {
    id: 'hosting.pages_collection.event_activities',
    defaultMessage: 'Event activities'
  },
  event_rules: {
    id: 'hosting.pages_collection.event_rules',
    defaultMessage: 'Event rules'
  }
});
export default [
  { page: 'food_beverage', label: translationMessages.food_beverage, icon: Lunch },
  { page: 'alcoholic_beverages', label: translationMessages.alcoholic_beverages, icon: DrinkAlcoholic },
  { page: 'furniture', label: translationMessages.furniture, icon: TableSettings },
  { page: 'restrooms', label: translationMessages.restrooms, icon: Toilet },
  { page: 'av_music', label: translationMessages.av_music, icon: Stereo },
  { page: 'event_activities', label: translationMessages.event_activities, icon: PingPong },
  { page: 'event_rules', label: translationMessages.event_rules, icon: Security }
];
